import { ActionField, Field } from '@oscar/form';
import {
  Button,
  Dropdown,
  Icon,
  Input,
  Layout,
  Loading,
  Menu,
  Radio,
  Select,
  Col,
  Row,
} from '@oscar/theme';
import { FormList, TextField } from 'common/components';
import { APIS } from 'common/constants/endpoints';
import { SAP_STATUS_LIST } from 'common/constants/insulation';
import moment from 'moment';
import React, { FormEvent, useEffect, useState } from 'react';
import { StatusInstance } from 'views/pages/create-instrulation/hooks/useStatus';
import CreateForm from './CreateForm';
import { SearchResult } from './SearchResult';
import '../style.scss';
import { stat } from 'fs';

export interface Notification {
  id: string;
  saP_NotificationId: string;
  saP_Status: string;
  saP_JobDescription: string;
  saP_FunctionalLocation: number;
  saP_LocationDescription: string;
  saP_Priority: string;
  saP_MaintenanceOrder: string;
  saP_StartDate: string | any;
  isLocal?: boolean;
}

const { Option } = Select;
const { TextArea } = Input;

const NotificationItem = (item: Notification) => {
  return (
    <TextField
      label={
        item.saP_NotificationId ? item.saP_NotificationId : '<Auto-generated>'
      }
      value={item.saP_Status}
      primary
      mappingData={SAP_STATUS_LIST}
    />
  );
};

const SearchContent = (props: any) => {
  const { setItem, valueSearchRequest, setValueSearchRequest } = props;
  // const [searchValue, setSearchValue] = useState('');
  const [searchType, setSearchType] = useState('notificationId'); //Default

  const changeDescription = () => {
    return searchType === 'notificationId'
      ? 'Already created a Notification in SAP? Search the Notification No. here'
      : 'Already created a Maintenance Order? Search the Maintenance Order No. here';
  };

  return (
    <Layout.Content>
      <span style={{ marginRight: '16px' }}>SAP ID</span>
      <Select
        defaultValue="notificationId"
        style={{ width: 250 }}
        onChange={value => {
          setSearchType(value);
        }}
      >
        <Option value="notificationId">Notification ID</Option>
        <Option value="maintenanceOrder">Maintenance Order ID</Option>
      </Select>
      {/* <Button>
        {searchType === 'notificationId'
          ? 'SAP Notification ID'
          : 'Maintenance Order ID'}
      </Button> */}
      <div className="search-container">
        <div className="description">{changeDescription()}</div>

        <ActionField
          name="searchNotification"
          onResponseData={res => {
            if (res?.status === 204) {
              setItem?.({
                [searchType === 'notificationId'
                  ? 'saP_NotificationId'
                  : 'saP_MaintenanceOrder']: valueSearchRequest,
                isLocal: true,
              });
              // setSearchValue('');
            } else {
              setItem?.(res);
            }
          }}
          request={{
            name:
              searchType === 'notificationId' ? 'notificationId' : 'monumber',
            method: 'GET',
            url:
              searchType === 'notificationId'
                ? APIS.NOTIFICATION_SEARCH
                : APIS.MAINTENANCE_SEARCH,
            nextParams: (nextProps: any) => {
              return {
                [searchType === 'notificationId'
                  ? 'notificationId'
                  : 'monumber']: valueSearchRequest,
              };
            },
          }}
        >
          {(searchProps: any) => {
            const handleSearch = () => {
              if (
                valueSearchRequest &&
                valueSearchRequest?.replace(/\s/g, '')?.length >= 8
              ) {
                if (searchType === 'notificationId') {
                  searchProps?.submitData({ id: valueSearchRequest }, true);
                } else {
                  searchProps?.submitData({ id: valueSearchRequest }, true);
                }
              } else {
                setItem?.({
                  [searchType === 'notificationId'
                    ? 'saP_NotificationId'
                    : 'saP_MaintenanceOrder']: valueSearchRequest,
                  isLocal: true,
                });
              }
            };

            return (
              <>
                <Input
                  prefix={
                    searchProps?.isLoading ? (
                      <Loading />
                    ) : (
                      <Button type="link" size="small" onClick={handleSearch}>
                        <Icon icon="search" />
                      </Button>
                    )
                  }
                  placeholder={
                    searchType === 'notificationId'
                      ? 'Notification ID'
                      : 'Maintenance Order ID'
                  }
                  size={'large'}
                  maxLength={15}
                  value={valueSearchRequest}
                  onChange={(event: FormEvent<HTMLInputElement>) => {
                    setValueSearchRequest(event.currentTarget.value);
                  }}
                  onPressEnter={handleSearch}
                />
              </>
            );
          }}
        </ActionField>
      </div>
    </Layout.Content>
  );
};
interface Props {
  statusRequest?: StatusInstance;
}

export default ({ statusRequest }: Props) => {
  const [isReasonVisible, setReasonVisibility] = useState(true);
  // const [isWorkDetailRequire, setIsWorkDetailRequire] = useState('');

  return (
    <div className="work-detail">
      {statusRequest?.state === 'EDIT' && (
        <div className="search-required">
          <div className="search-required-text">Working Require</div>
          <Field name="isWorkDetailRequire">
            <Radio.Group disabled={false}>
              <Radio value={true} onChange={() => setReasonVisibility(true)}>
                Yes
              </Radio>
              <Radio value={false} onChange={() => setReasonVisibility(false)}>
                No
              </Radio>
            </Radio.Group>
          </Field>
        </div>
      )}
      {statusRequest?.state === 'EDIT' && !isReasonVisible && (
        <div>
          <p>Please state your reason*</p>
          <Field name="workDetailRemarks">
            <TextArea
              placeholder="minimum 20 characters"
              autoSize={{ minRows: 3, maxRows: 4 }}
              className="work-DetailRemarks"
              maxLength={250}
              // onChange={e => {
              //   setIsWorkDetailRequire(e.target.value);
              // }}
            />
          </Field>
        </div>
      )}
      {statusRequest?.state === 'VIEW' && (
        <Field name="workDetailRemarks">
          <TextField label="Work Detail Remarks" />
        </Field>
      )}
      {isReasonVisible && (
        <FormList<Notification>
          keyField="saP_NotificationId"
          title="Notification ID"
          name="listWorkDetail"
          headerComponent={
            isReasonVisible && statusRequest?.state === 'EDIT'
              ? SearchContent
              : undefined
          }
          detailComponent={SearchResult}
          onItemRenderer={NotificationItem}
          defaultValueAdded={() => {
            return {
              saP_Status: 'OSNO',
              saP_StartDate: moment(),
            };
          }}
          addedComponent={CreateForm}
          readOnly={true}
          requireFields={[
            'saP_Status',
            'saP_JobDescription',
            'saP_FunctionalLocation',
            'saP_Priority',
            'saP_StartDate',
          ]}
        />
      )}
    </div>
  );
};
